import React from 'react'
import { Alert, Box, Card, CardContent, CardHeader, Divider, Grid, Tab, Tabs } from '@mui/material'
import T from 'T'
import MakePayment from 'components/payments/PaymentActions/MakePayment'
import AddPaymentMethod from 'components/payments/PaymentActions/AddPaymentMethod'
import usePaymentProvider from 'hooks/usePaymentProvider'

const a11yProps = index => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const PaymentActions = () => {
  const [value, setValue] = React.useState(0)
  const { isInactive } = usePaymentProvider()

  const isMakePaymentTab = value === 0
  const isAddPaymentMethodTab = value === 1

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const gridItemSize = { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }

  if (isInactive) {
    return (
      <Card elevation={0} variant="outlined">
        <CardContent>
          <Alert severity="info">{T.PAYMENT_SERVICES_UNAVAILABLE}</Alert>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card elevation={0} variant="outlined">
      <CardHeader
        title={
          <>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab sx={{ textTransform: 'none' }} label={T.MAKE_A_PAYMENT} {...a11yProps(0)} />
              <Tab sx={{ textTransform: 'none' }} label={T.ADD_PAYMENT_METHOD} {...a11yProps(1)} />
            </Tabs>
            <Divider />
          </>
        }
      />
      <CardContent>
        {isMakePaymentTab && <MakePayment />}
        {isAddPaymentMethodTab && (
          <Grid container xs={12} sx={{ width: '100%' }}>
            <Grid item container {...gridItemSize}>
              <Box width="100%">
                <AddPaymentMethod />
              </Box>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  )
}

export default PaymentActions
